import React from 'react';
import { LazyComponent } from '../LazyComponent/LazyComponent';
import { NotableClientsProps } from './types';

const lazyImport = () => import(/* webpackChunkName: 'NotableClients' */ './NotableClientsResolver');

export const LazyNotableClients: React.FC<NotableClientsProps> = (props) => (
    <LazyComponent moduleName="NotableClients" lazyImport={lazyImport} componentProps={props} />
);
